import * as React from 'react';
import { useBloomreachAppointmentContent } from '@grandvisionhq/bloomreach';
import { useAppointmentContext } from '../context/AppointmentContext.js';
import { usePageData } from '../context/PageDataContext.js';

const useAppointmentTypes = ()=>{
    const pageData = usePageData();
    const [, { store  }] = useAppointmentContext();
    const { appointmentDisplayType  } = useBloomreachAppointmentContent();
    const isAabGrouped = appointmentDisplayType === 'group';
    const sortedAppointmentTypes = React.useMemo(()=>{
        var ref4;
        const appointmentTypes = (ref4 = store === null || store === void 0 ? void 0 : store.appointmentTypes) !== null && ref4 !== void 0 ? ref4 : [];
        return appointmentTypes.sort((a, b)=>{
            var ref;
            const pageTypes = (ref = pageData.appointmentTypes) !== null && ref !== void 0 ? ref : [];
            const aIndex = pageTypes.findIndex(({ typeId  })=>typeId === a.id
            );
            const bIndex = pageTypes.findIndex(({ typeId  })=>typeId === b.id
            );
            if (aIndex === -1) {
                return 1;
            } else if (bIndex === -1) {
                return -1;
            } else {
                return aIndex - bIndex;
            }
        });
    }, [
        pageData,
        store
    ]);
    const groupedAppointmentTypeIcons = React.useMemo(()=>{
        var ref;
        if (!isAabGrouped) {
            return {};
        }
        var ref5;
        return (ref5 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, appointmentGroup)=>{
            appointmentGroup.appointmentTypes.forEach((entry)=>{
                if (entry.icon !== undefined) {
                    acc[entry.typeId] = entry.icon;
                }
            });
            return acc;
        }, {})) !== null && ref5 !== void 0 ? ref5 : {};
    }, [
        isAabGrouped,
        pageData
    ]);
    var ref3;
    const appointmentTypeIcons = React.useMemo(()=>{
        var ref;
        return (ref3 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.icon !== undefined) {
                acc[entry.typeId] = entry.icon;
            }
            return acc;
        }, {})) !== null && ref3 !== void 0 ? ref3 : {};
    }, [
        pageData
    ]);
    const groupedAppointmentGlobalLabels = React.useMemo(()=>{
        var ref;
        if (!isAabGrouped) {
            return {};
        }
        var ref6;
        return (ref6 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, appointmentGroup)=>{
            appointmentGroup.appointmentTypes.forEach((entry)=>{
                if (entry.globalLabel !== undefined) {
                    acc[entry.typeId] = entry.globalLabel;
                }
            });
            return acc;
        }, {})) !== null && ref6 !== void 0 ? ref6 : {};
    }, [
        isAabGrouped,
        pageData
    ]);
    var ref1;
    const appointmentGlobalLabels = React.useMemo(()=>{
        var ref;
        return (ref1 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.globalLabel !== undefined) {
                acc[entry.typeId] = entry.globalLabel;
            }
            return acc;
        }, {})) !== null && ref1 !== void 0 ? ref1 : {};
    }, [
        pageData
    ]);
    const groupedAppointmentTypeToolTips = React.useMemo(()=>{
        var ref;
        if (!isAabGrouped) {
            return {};
        }
        var ref7;
        return (ref7 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, appointmentGroup)=>{
            appointmentGroup.appointmentTypes.forEach((entry)=>{
                if (entry.typeDetails !== undefined) {
                    acc[entry.typeId] = entry.typeDetails;
                }
            });
            return acc;
        }, {})) !== null && ref7 !== void 0 ? ref7 : {};
    }, [
        isAabGrouped,
        pageData
    ]);
    var ref2;
    const appointmentTypeToolTips = React.useMemo(()=>{
        var ref;
        return (ref2 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.typeDetails !== undefined) {
                acc[entry.typeId] = entry.typeDetails;
            }
            return acc;
        }, {})) !== null && ref2 !== void 0 ? ref2 : {};
    }, [
        pageData.appointmentTypes
    ]);
    const groupedAppointmentTypes = React.useMemo(()=>{
        if (isAabGrouped) {
            var ref8;
            const groupedAppointmentsData = (ref8 = pageData.appointmentTypes) === null || ref8 === void 0 ? void 0 : ref8.map((appointmentGroup)=>{
                var ref;
                const appointmentTypesFromQuery = (ref = store === null || store === void 0 ? void 0 : store.appointmentTypes) !== null && ref !== void 0 ? ref : [];
                const groupedAppointmentTypesData = appointmentTypesFromQuery.filter((appointmentTypeFromQuery)=>{
                    return appointmentGroup.appointmentTypes.some((type)=>type.typeId === appointmentTypeFromQuery.id
                    );
                }).sort((a, b)=>{
                    const aIndex = appointmentGroup.appointmentTypes.findIndex(({ typeId  })=>typeId === a.id
                    );
                    const bIndex = appointmentGroup.appointmentTypes.findIndex(({ typeId  })=>typeId === b.id
                    );
                    if (aIndex === -1) {
                        return 1;
                    } else if (bIndex === -1) {
                        return -1;
                    } else {
                        return aIndex - bIndex;
                    }
                });
                return {
                    title: appointmentGroup.title,
                    icon: appointmentGroup.icon,
                    appointmentTypes: groupedAppointmentTypesData
                };
            });
            return groupedAppointmentsData;
        }
        return [];
    }, [
        isAabGrouped,
        pageData.appointmentTypes,
        store === null || store === void 0 ? void 0 : store.appointmentTypes
    ]);
    return React.useMemo(()=>({
            sortedAppointmentTypes,
            appointmentTypeIcons,
            appointmentGlobalLabels,
            appointmentTypeToolTips,
            groupedAppointmentTypes,
            groupedAppointmentTypeIcons,
            groupedAppointmentTypeToolTips,
            groupedAppointmentGlobalLabels
        })
    , [
        sortedAppointmentTypes,
        appointmentTypeIcons,
        appointmentGlobalLabels,
        appointmentTypeToolTips,
        groupedAppointmentTypes,
        groupedAppointmentTypeIcons,
        groupedAppointmentTypeToolTips,
        groupedAppointmentGlobalLabels, 
    ]);
};

export { useAppointmentTypes as default, useAppointmentTypes };
//# sourceMappingURL=use-appointment-types.js.map
